import { QueryClient } from '@tanstack/react-query';

import { logger } from '@/lib/sentry';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => logger.error(error),
    },
  },
});
